<template>
  <div>
    <p>{{ $t("节点配置") }}</p>

    <t-form-item
      name="newTaskID"
      :required-mark="false"
      :rules="[
        {
          required: true,
          message: $t('不能为空'),
          trigger: 'change',
        },
      ]"
      style="margin-bottom: 12px"
    >
      <template #label>
        <text-with-mark :text="$t('选择任务流')" />
      </template>
      <t-select v-model="formData.newTaskID" :options="taskFlows" filterable />
    </t-form-item>
    <div>
      <span style="color: #6d778c; padding-right: 8px">{{
        $t("将已有的工作流集成到此流程中，执行嵌套任务")
      }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { inject, reactive, Ref, toRefs, watch } from "vue";

type OptionType = Array<{ value: string; label: string }>;

const emit = defineEmits(["updateData"]);

const getTaskFlowsFn = inject<Ref<() => Promise<OptionType>>>("getTaskFlows");

type Model = {
  nodeData: {
    newTaskID?: string;
  };
};

const props = defineProps<{
  data: Model["nodeData"];
  visible: boolean;
}>();

const formData = reactive<Model["nodeData"]>({
  newTaskID: props.data.newTaskID ?? "",
});

const taskFlows = reactive<OptionType>([]);

const getOptions = () => {
  if (getTaskFlowsFn?.value) {
    getTaskFlowsFn.value().then((data) => {
      console.log("data", data);
      taskFlows.splice(0, taskFlows.length, ...data);
    });
  }
};

watch(formData, (newVal, oldVal) => {
  emit("updateData", newVal);
});

const { visible } = toRefs(props);

watch(
  visible,
  (newVal) => {
    if (newVal) {
      getOptions();
    }
  },
  { immediate: true },
);
</script>
<style lang="less" scoped></style>
